import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Breadcrumbs from '@eversports/klimt-primitives/legacy/Breadcrumbs'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import ArrowBackwards from '../../assets/icons/arrow-backwards.svg'
import { Localized, useIntl } from '../../localization/react'

interface Props {
  unreadNotificationsCount: number | null
}

const Navigation = ({ unreadNotificationsCount }: Props) => {
  const intl = useIntl()
  return (
    <Stack
      padding={{ xs: 4, sm: 6 }}
      paddingX={{ xs: 4, sm: 0 }}
      sx={{ backgroundColor: { xs: 'white', sm: 'transparent' }, boxShadow: { xs: boxShadows.default, sm: 'none' } }}
      gap={3}
    >
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/" ariaLabel={intl.breadcrumbNavigationItemHome()}>
          <Text sx={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            <Localized id="breadcrumb-navigation-item-home" />
          </Text>
        </Link>
        <Text>
          <Localized id="breadcrumb-navigation-item-notifications" />
        </Text>
      </Breadcrumbs>
      <Stack direction="row" alignItems="center" gap={2}>
        <Link to="/" ariaLabel={intl.breadcrumbNavigationItemHome()}>
          <Icon src={ArrowBackwards} size="default" color="midnight" />
        </Link>
        <Stack direction="row" gap={3}>
          <Heading is="h1">
            <Localized id="notifications-page-title" />
          </Heading>
          {Boolean(unreadNotificationsCount) && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              paddingX={2}
              paddingY={1}
              borderRadius={1}
              backgroundColor="red"
            >
              <Text variant="xsmall" sx={{ color: 'white' }}>
                {unreadNotificationsCount}
              </Text>
            </Box>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Navigation
